<template>
  <div>
    
<FormKitLazyProvider config-file="true">
<Message
      v-for="(message, index) in messages"
      :key="index"
      :type="message.type"
      aria-close-label="Schliessen"
      class="mb-6"
    >
      <p v-html="message.message" />
    </Message>
    <div v-if="!user.loggedIn">
      <FormKit id="loginForm" type="form" :actions="false" @submit="onSubmit">
        <FormKit
          id="username"
          v-model="login.username"
          autocomplete="name"
          name="username"
          validation="required"
          :label="$texts('email', 'E-Mail')"
        />
        <FormKit
          id="password"
          v-model="login.password"
          type="password"
          name="password"
          validation="required"
          :label="$texts('password', 'Passwort')"
        />
        <FormKit
          type="submit"
          :disabled="state.isSending"
          class="button is-primary"
        >
          {{ $texts('login', 'Anmelden') }}
        </FormKit>
      </FormKit>
    </div>
    <forms-login-logged-in v-if="user.loggedIn" />
</FormKitLazyProvider>

  </div>
</template>

<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import { reset } from '@formkit/core'

const route = useRoute()
const { $texts } = useNuxtApp()
const props = defineProps<{
  successUrl?: string
}>()

const destination = computed(() => {
  if (props.successUrl) {
    return props.successUrl
  }
  const url = route.query.destination
  if (url && typeof url === 'string' && !url.startsWith('http')) {
    return url
  }
  return ''
})

const user = useDrupalUser()
type Message = {
  type: string
  message: string
}

const messages = ref<Message[]>([])
const state = ref({
  isSending: false,
})

const login = ref({
  username: '',
  password: '',
})

const onSubmit = async () => {
  state.value.isSending = true

  const loginResult = await userLogin(
    login.value.username,
    login.value.password,
    destination.value,
  )
  state.value.isSending = false

  if (loginResult) {
    messages.value.push({
      type: 'is-danger',
      message: loginResult,
    })
  }

  reset('loginForm')
}
</script>
